import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'

import './assets/scss/main.scss'

import Router from 'vue-router'
import VueRouterBackButton from 'vue-router-back-button'

Vue.use(Router)
Vue.use(VueRouterBackButton, { router })

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
